const startedUpload = function ({ commit, dispatch }, id) {
  commit("STARTED_UPLOAD", id);
  dispatch("validateSubmission");
  return Promise.resolve(id);
};

export default startedUpload;
